var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMarkPriceFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFAA47",
  fillRule: "evenodd",
  d: "M.434.176a1 1 0 0 1 .925-.11l8 3.078a1 1 0 0 1 .01 1.862L2 7.932V11a1 1 0 1 1-2 0V1A1 1 0 0 1 .434.176ZM2 5.78l4.253-1.688L2 2.456V5.78Z",
  clipRule: "evenodd"
})));
export default SvgMarkPriceFlag;